import { Component, ComponentFactoryResolver, Input, OnChanges, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import * as possibleComponents from '../../shared/thank-you-banner/banners';

@Component({
    selector: 'thank-you-banner',
    templateUrl: './thank-you-banner.component.html',
    styleUrls: ['./thank-you-banner.component.css'],
    standalone: false
})
export class ThankYouBannerComponent implements OnInit, OnChanges, OnDestroy { 
  @Input() generateOnShow: boolean = false;
  @ViewChild("bannerContainer", {static: false, read: ViewContainerRef}) bannerContainer: ViewContainerRef;

  private audio = new Audio();

  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
  }

  ngOnChanges(): void {
    if(this.generateOnShow) {
      setTimeout(() => {
        this.generateBanner();
      }, 100);
    }
  }

  ngOnDestroy(): void {
    this.audio.pause();
    this.audio.remove();
  }

  public generateBanner(): void {
    let componentArray: Array<any> = new Array<any>();
    for(var key in possibleComponents ){
      componentArray.push(possibleComponents[key]);
    }
    
    const rndInt = Math.floor(Math.random() * componentArray.length) + 1
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentArray[rndInt - 1]);
    this.bannerContainer.clear();
    this.bannerContainer.createComponent(componentFactory);

    this.audio = new Audio();
    this.audio.src = "../../../assets/sounds/Thank You Sound.wav";
    this.audio.load();
    this.audio.volume = 0.5;
    this.audio.play();
  }
  public removeBanner(): void {
    this.bannerContainer.clear();
    this.audio.pause();
    this.audio.remove();
  }
}
